import axios, { AxiosRequestConfig } from 'axios';

const ZENDESK_URL = '/v2/zendesk-user';

interface jwtResponse {
  data?: string;
}

class ZendeskJwtService {
  static getJwt(userId: number, config?: AxiosRequestConfig): Promise<jwtResponse> {
    return axios.get(`${ZENDESK_URL}/${userId}/jwt`, config);
  }

  static syncUser(userId: number, config?: AxiosRequestConfig): Promise<void> {
    return axios.put(`${ZENDESK_URL}/${userId}/sync`, undefined, config);
  }

  static createUser(userId: number, config?: AxiosRequestConfig): Promise<void> {
    return axios.post(`${ZENDESK_URL}?id=${userId}`, undefined, config);
  }
}

export { ZendeskJwtService };
